import {createSlice} from "@reduxjs/toolkit";

const initialState = {
        theme: 'light',
}


const configurationSlice = createSlice({
    name: 'configuration',
    initialState,
    reducers: {
        setTheme: (state, action) => {
            state.configuration.theme = action.payload
        }
    }
})

export const {setTheme} = configurationSlice.actions

export default configurationSlice.reducer